{
  "main": {
    "title": "Logbook Overview",
    "nazaj": "Back"
  },
  "navs": {
    "brisanje": "Deletions",
    "urejanje": "Edits"
  },
  "table": {
    "titleJ": "GLIDER FLIGHTS",
    "titleM": "POWERED FLIGHTS"
  },
  "modal": {
    "izbrisal": "Record deleted by:",
    "reg": "registration:",
    "vlecno": "tow aircraft:",
    "pilot": "pilot:",
    "instruktor": "instructor:",
    "namen": "purpose:",
    "naloga": "task:",
    "krajV": "takeoff location:",
    "krajP": "landing location:",
    "casV": "takeoff time:",
    "casP": "landing time:",
    "casL": "flight time:",
    "stPristankov": "number of landings:",
    "ifr": "ifr:",
    "nocno": "night:",
    "vizuelno": "visual:",
    "opomba": "note:",
    "datumL": "flight date:",
    "datumV": "entry date:",
    "datumB": "deletion date:",
    "regV": "tow reg.:",
    "casO": "release time:",
    "casVL": "tow time:"
  }
}